import { Button, Container, Grid } from '@aurecon-creative-technologies/styleguide'
import { FC, useState, useEffect } from 'react'

import { bulkFilesList, projectFilesList } from '../api/StorageAPI'
import Page from '../components/Page'
import Style from '../styles/AddProjectPage.module.sass'

export interface IAzureProps {
  name: string
  length: number
}

const Storage: FC = () => {
  const [data, dataSet] = useState<IAzureProps[]>([])

  const [sorted, sortedSet] = useState<IAzureProps[]>([])

  useEffect(() => {
    const sortedData = [...data].sort((a, b) => b.name.localeCompare(a.name))
    sortedSet(sortedData)
  }, [data])

  const handleListProjectFiles = async () => {
    try {
      const response = await projectFilesList({})
      if (response?.success) {
        dataSet(response?.data?.files)
      } else {
        alert('Failed to fetch  files. Please check the server logs for more details.')
      }
    } catch (exception) {
      console.error('Error fetching project files:', exception)
    }
  }

  const handleListBulkFiles = async () => {
    try {
      const response = await bulkFilesList({})
      if (response?.success) {
        console.log('Bulk Response:', response)
        dataSet(response?.data?.files)
      } else {
        alert('Failed to fetch bulk update files. Please check the server logs for more details.')
      }
    } catch (exception) {
      console.error('Error fetching bulk update files:', exception)
    }
  }

  return (
    <Page footer>
      <Container cssClass={Style.pageWrapper}>
        <Grid cssClass={Style.body}>
          <Grid item cssClass={Style.content} xs={12}>
            <Button label='Project Files' onClick={handleListProjectFiles} />
            <Button label='Bulk Update Files' onClick={handleListBulkFiles} />
          </Grid>
          <Grid item cssClass={Style.content} xs={12}>
            <table>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Length</th>
                </tr>
              </thead>
              <tbody>
                {sorted &&
                  sorted.map((item, index) => (
                    <tr key={index}>
                      <td>{item.name}</td>
                      <td>{item.length}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </Grid>
        </Grid>
      </Container>
    </Page>
  )
}

export default Storage
